@if (districts?.length) {
  <ul class="list-unstyled card p-3">
    @for (district of districts; track district.id) {
      <li>{{ district.name }}</li>
    }
  </ul>
}
